module.exports = __webpack_public_path__ + "img/ascenti-mosaic-logo-white.5d66e238.png";